import { useEffect } from "react";
//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End



const useWFHMessages = (eventName, callBack) => {
    //Prachi T - 02-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
    //to change font color on touchline data change
    // useFontColor(callBack)
    //Prachi T - 02-11-2023 - BT-110050 - Breeze- Settings Preferences - End

    useEffect(() => {
        function handle(event) {
            callBack(event);
        }
        window.addEventListener(eventName, handle);
        return () => window.removeEventListener(eventName, handle);

    }, [callBack, eventName]);
};

export default useWFHMessages;